module.exports = __webpack_public_path__ + "static/logo-6c1d6c67d164815e2e28b4ddafc17185.png";